import { PageSection } from "@/app/common/components/composite/layout/PageSection";
import { EngineeringList } from "./EngineeringList";
import {
  serviceTierHeadings,
  serviceTierStatements,
  type ServiceRecord,
} from "@/content/services";

export type ServiceGroundingProps = {
  service: ServiceRecord;
};

// Owns the tier claim on a service detail page: a heading derived from `tier`
// (never authored per record — see content/services/index.ts for why §7 makes
// that the load-bearing detail), over either what the service has actually built
// or, for a record that has none yet, the fallback sentence.
export function ServiceGrounding({ service }: ServiceGroundingProps) {
  const heading = serviceTierHeadings[service.tier];
  const hasEngineering = Boolean(service.engineering?.length);

  return (
    <PageSection
      title={heading}
      body={hasEngineering ? undefined : [serviceTierStatements[service.tier]]}
    >
      {service.engineering && service.engineering.length > 0 && (
        <EngineeringList items={service.engineering} ariaLabel={heading} />
      )}
    </PageSection>
  );
}
